module.exports = __webpack_public_path__ + "static/18-616c7c9fe9ba6bcd4ddc2419ee91b722.jpg";